import React from "react";
import styled from "styled-components";

export default function FullButton({ title, action, border }) {
  return (
    <Wrapper
      className="animate pointer radius8"
      onClick={action ? () => action() : null}
      border={border}
    >
      {title}
    </Wrapper>
  );
}

const Wrapper = styled.button`
  border: 1px solid ${(props) => (props.border ? "#A1A4A6" : "#F20F0F")};
  background-color: ${(props) => (props.border ? "transparent" : "#F20F0F")};
  width: 100%;
  padding: 15px;
  outline: none;
  color: ${(props) => (props.border ? "#590707" : "#fff")};
  :hover {
    background-color: ${(props) => (props.border ? "transparent" : "#580cd2")};
    border: 1px solid #f20f0f;
    color: ${(props) => (props.border ? "#F20F0F" : "#fff")};
  }
`;
